angular.module('services.newman.PaginationService', [
  'global'
])

/**
 * The PaginationService service handles paginating models.
 *
 * @class PaginationService
 * @constructor
 * @module services.newman.PaginationService
 */
.factory('PaginationService', [
  'ApiService',
  'ModelsService',
  '$timeout',
  function (ApiService, ModelsService, $timeout) {
    'use strict';

    var service = {

      paginations: {},

      /**
       * Paginates a model
       *
       * @param {string} [model] - model to paginate
       * @param {string} [uri] - api path
       * @param {Object} [params] - url config params
       */
      paginate: function get(model, uri, params) {
        var href = uri + '?';
        var apiReturn;

        if (service.paginations['paginated-' + model]) {
          return {};
        }

        if (!params.headers) {
          params.headers = true;
        }

        _.forOwn(params, function (o, k) {
          if (k !== 'headers' && k !== 'server' && k !== 'token') {
            href = href + k + '=' + o + '&';
          }
        });

        href = href.slice(0, -1);

        if (params.server) {
          apiReturn = ApiService.remoteRequest(href, params)
            .then(function (response) {
              service.write(model, response, params);
              return response;
            })
            .catch(function (response) {
              console.log(model);
              console.log(response);
              throw response;
            });
        } else {
          apiReturn = ApiService
            .execute(href, 'GET', true, true)
            .then(function (response) {
              service.write(model, response, params);
              return response;
            })
            .catch(function (response) {
              console.log(model);
              console.log(response);
              throw response;
            });
        }
        return apiReturn;
      },

      /**
       * Writes data to a model.
       *
       * @param {string} model - Model identifier
       * @param {Object} data - JSON data
       * @param {Object} params - pagination cofiguration object
       * @return {Object} JSON data
       */
      write: function write(model, data, params) {
        var totalRecords = data.headers['x-totalcount'] ? parseInt(data.headers['x-totalcount'], 10) : params.limit;
        var pageinationObject = {
          initializing: 0,
          currentPage: 0,
          filters: [],
          totalRecords: totalRecords,
          recordsPerPage: params.perpage || params.limit,
          records: data.data,
          numPages: service.numPages,
          toggleFilters: service.toggleFilters,
          totalPages: Math.ceil(totalRecords / (params.perpage || params.limit)),
          setCurrentPage: service.setCurrentPage,
          showingRecords: service.showingRecords,
          inGroups: service.inGroups,
          filterPages: service.filterPages,
          fullset: false
        };

        service.paginations['paginated-' + model] = pageinationObject;

        return service.paginations['paginated-' + model];
      },
      /**
       * Toggle Checkbox filters
       *
       * @param {Object} [filter] - the filter in question
       * @param {string} [fGroup] - the filter group
       */
      toggleFilters: function (filter, fGroup) {
        var allOn = _.filter(this.filters[fGroup], 'on');
        var that = this;
        // checks to see if all filters are turned on
        if (allOn.length === this.filters[fGroup].length) {
          _.forEach(this.filters[fGroup], function (f) {
            f.on = false;
          });
          filter.on = true;
        } else if (allOn.length === 1
          && allOn[0].on === true
          && allOn[0] === filter) {
          _.forEach(this.filters[fGroup], function (f) {
            f.on = true;
          });
        } else if (allOn.length < this.filters[fGroup].length) {
          filter.on = !filter.on;
        }

        $timeout(function () {
          that.filterPages();
        }, 0);
      },

      /**
       * adjusts pages based on filtered records
       *
       */
      filterPages: function () {
        var records = this.filteredRecords || this.records;
        this.currentPage = 0;
        this.totalPages = Math.ceil(records.length / this.recordsPerPage);
      },

      /**
       * Filters records in groups
       *
       * @param {Object} fGroup - the filter group in question
       */
      inGroups: function (fGroup) {
        var g;
        var allOn;
        if (this.filters[fGroup] === undefined) { return g; }
        allOn = _.filter(this.filters[fGroup], 'on');
        if (allOn.length === this.filters[fGroup].length) {
          g = 'all';
        } else {
          g = allOn;
        }

        return g;
      },
      /**
       * shows current number of records after filter
       *
       * @return {Integer} max - number of records
       */
      showingRecords: function () {
        var max;
        var totalRecords = this.filteredRecords ? this.filteredRecords.length : this.totalRecords;
        var lastPageRemainder = (totalRecords % this.recordsPerPage);
        var isLastPage = (this.currentPage + 1)
              === Math.ceil(totalRecords / this.recordsPerPage);

        if (!isLastPage && this.fullset) {
          max = (this.currentPage * this.recordsPerPage) + this.recordsPerPage;
        } else if (isLastPage && this.fullset) {
          max = (this.currentPage * this.recordsPerPage) + lastPageRemainder;
        } else if (!this.fullset) {
          max = this.totalRecords <= this.recordsPerPage ? this.totalRecords : this.recordsPerPage;
        }

        return max;
      },
      /**
       * updates the full record set
       *
       * @param {string} [model] - the model with the full set
       * @param {string} [filterOn] - the object property to build filters from
       */
      updateFullSet: function (model, filterOn) {
        var paginator = service.paginations['paginated-' + model];
        paginator.records = ModelsService.read(model);
        paginator.fullset = true;
        service.buildFilters(model, filterOn);
      },
      /**
       * PBuilds out the groups filter list
       *
       * @param {string} [model] - model to paginate
       * @param {string} [filterOn] - the object property to build filters from
       */
      buildFilters: function (model, filterOn) {
        var filters = {};
        if (!_.isArray(filterOn)) {
          filters[filterOn] = _.uniq(_.map(service.paginations['paginated-' + model].records, filterOn));
        } else {
          _.forEach(filterOn, function (on) {
            filters[on] = _.uniq(_.pluck(service.paginations['paginated-' + model].records, on), function (r) {
              var val;
              if (r === undefined) {
                val = 'No' + on;
              } else if (_.isString(r)) {
                val = r;
              } else {
                val = r.id;
              }

              return val;
            });
          });
        }

        service.paginations['paginated-' + model].filters = {};

        _.forEach(filters, function (f, k) {
          service.paginations['paginated-' + model].filters[k] = [];
          _.forEach(f, function (o) {
            var filter;
            if (!_.isPlainObject(o)) {
              filter = {
                id: o,
                label: o,
                on: true
              };
            } else if (k === 'content.user') {
              if (o.content) {
                filter = {
                  id: o.id,
                  label: o.content.firstName + ' ' + o.content.lastName,
                  on: true
                };
              } else if (o.firstName) {
                filter = {
                  id: o.id,
                  label: o.firstName + ' ' + o.lastName,
                  on: true
                };
              }
            } else {
              filter = {
                id: o.id,
                label: o.title || o.label,
                on: true
              };
            }
            service.paginations['paginated-' + model].filters[k].push(filter);
          });
        });
      },
      /**
       * creates an array of the number of pages to paginate
       *
       * @param {Integer} [pages] - number of pages to make
       * @param {Integer} [ellipsis] - how many pages to show
       * @return {Array} [array] - an array of numbers
       */
      numPages: function (pages, ellipsis) {
        var pageLength = pages;
        if (ellipsis) {
          pageLength = pages > ellipsis ? ellipsis : pages;
        }
        return new Array(pageLength);
      },
      /**
       * Gets the pagination model
       *
       * @param {string} [model] - the pagination model
       * @return {Object} [pagination] - the pagination object
       */
      get: function get(model) {
        return service.paginations['paginated-' + model];
      },
      destroy: function (model) {
        if (service.paginations['paginated-' + model]) {
          delete service.paginations['paginated-' + model];
        }
      }

    };

    return service;
  }
])

.filter('pageFilter', [
  function () {
    'use strict';

    return function (records, filterOn, properties, pagingInit) {
      var prop;
      var on = [];
      var lookup;
      var result;
      /* eslint-disable vars-on-top*/
      if (pagingInit) { return records; }

      _.forEach(properties, function (onOff, k) {
        // grab all on filters
        var tmpOn = _.filter(filterOn[k], { on: true });
        on = on.concat(tmpOn);
      });

      // index others by value passed
      lookup = _.indexBy(on, 'id');


      // // find all the things
      result = _.filter(records, function (r) {
        var passCount = 0;
        _.forEach(properties, function (val, opath) {
          var p = val !== '' ? opath + '.' + val : opath;
          prop = _.pluck([r], p)[0];
          // console.log(lookup[prop]);
          passCount = lookup[prop] !== undefined ? passCount + 1 : passCount;
        });

        return passCount === _.size(properties);
      });

      return result;
    };
  }
])

.directive('exportToCsv', [
  function () {
    'use strict';

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function (e) {
          var reportTitle = attrs.exportToCsv.replace(/[^a-z0-9]/gi, '-');
          var table = e.target.nextElementSibling;
          var csvString = '';
          /* eslint-disable no-plusplus*/
          for (var i = 0; i < table.rows.length; i++) {
            var rowData = table.rows[i].cells;
            for (var j = 0; j < rowData.length; j++) {
              csvString = csvString + '"' + rowData[j].textContent.replace(/\s\s+/g, ' ').replace(/(\r\n|\n|\r)/gm, '').replace(/scvbr/mg, '\n').trim() + '",';
            }
            csvString = csvString.substring(0, csvString.length - 1) + '\n';
          }
          csvString = csvString.substring(0, csvString.length - 1);
          var a = angular.element('<a/>', {
            style: 'display:none',
            href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString))),
            download: reportTitle + '.csv'
          }).appendTo('body');
          a[0].click();
          a.remove();
        });
      }
    };
  }]);
